export enum ApiExternalEnum {
  BZV = 'https://api.bazaarvoice.com/',
}
